export default "__VITE_ASSET__BdpaEEo8__"